export const sendRequest = payload => ({
  url: '/feedback/send-request/',
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload)
})
